import logoMedihill from 'assets/images/logo_medihill.png'
import logoDefault from 'assets/images/logo_default.png'
import logoSmartMonitor from 'assets/images/logo_smart_monitor.png'

const logoMapping = {
  medihill: logoMedihill,
  "smart-monitor": logoSmartMonitor,
  default: logoDefault // Fallback logo
};

export const getLogoPath = (organizationName) => {
  return logoMapping[organizationName] || logoMapping.default;
};

export default logoMapping;
